import { combineReducers } from 'redux'
import merchantReducer from './merchantReducer'
import userReducer from './userReducer'

export default combineReducers({
  user: userReducer,
  merchant: merchantReducer,
})
